import { render } from "./PharmaAppointments.vue?vue&type=template&id=7f6740ee&scoped=true&ts=true"
import script from "./PharmaAppointments.vue?vue&type=script&lang=ts"
export * from "./PharmaAppointments.vue?vue&type=script&lang=ts"

import "./PharmaAppointments.vue?vue&type=style&index=0&id=7f6740ee&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6740ee"]])

export default __exports__